import React from 'react'

const AccessGroupsMapping = () => {
  return (
    <div>AccessGroupsMapping</div>
  )
}

export default AccessGroupsMapping;